import { t } from "i18next";
import {
	GridActionsCellItem,
	GridColDef,
	GridRowParams,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotificationContext } from "../../../context/notificationcontext";
import { Check } from "@mui/icons-material";
import moment from "moment";
import ListPageDX from "../../../components/business/listpagedx";
import { useAuthContext } from "../../../context/authcontext";
import useInboundRequestService from "../../../shared/services/inboundrequestservice";
import { DATE_FORMAT } from "../../../shared/globals";
import { useTenantContext } from "../../../context/tenantcontext";

const CountList = (props: any) => {
	const navigate = useNavigate();
	const { userData } = useAuthContext();
	const { tenantId } = useTenantContext();
	const { setError } = useNotificationContext();
	const { getInboundRequestsByStatus } = useInboundRequestService();

	const [Counts, setCounts] = useState<any[]>([]);
	const [rows, setRows] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	const CountColumns: GridColDef[] = [
		{
			field: "grnNumber",
			headerName: `${t("GRN No.")}`,
			flex: 1,
		},
		{
			field: "inboundRequestId",
			headerName: `${t("Request No.")}`,
			minWidth: 200,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "recievingDate",
			headerName: `${t("Receiving Date")}`,
			minWidth: 200,
			align: "center",
			headerAlign: "center",
			valueFormatter(params) {
				return params.value ? moment(params.value).format(DATE_FORMAT) : "";
			},
		},
		// {
		//   headerName: t("Actions"),
		//   field: "actions",
		//   type: "actions",
		//   getActions: buildActions,

		//   sortable: false,
		//   filterable: false,
		//   disableColumnMenu: true,
		// },
	];

	if (userData.userType === "S") {
		const customerNameColumn = {
			field: "customerName",
			headerName: `${t("Customer Name")}`,
			flex: 1,
		};
		CountColumns.splice(1, 0, customerNameColumn);
	}

	const buildActions = (params: GridRowParams) => {
		let actionsArray = [];

		actionsArray.push(
			<GridActionsCellItem
				label={t("Count")}
				showInMenu
				onClick={() => {
					onEdit(params.row);
				}}
				icon={<Check />}
			/>
		);

		return actionsArray;
	};

	const onEdit = (data: any) => {
		navigate(`/countingpanel/${data.inboundRequestId}`);
	};

	const getData = () => {
		setIsLoading(true);
		const operation =
			userData?.userType === "S"
				? getInboundRequestsByStatus(tenantId, 7)
				: getInboundRequestsByStatus(null, 7);
		operation
			.then((response: any) => {
				let updatedRows = response.map((request: any) => ({
					...request,
					recievingDate: moment(request.recievingDate).format(DATE_FORMAT),
				}));
				// sort desc by date
				updatedRows.sort((a: any, b: any) =>
					moment(a.recievingDate).isBefore(moment(b.recievingDate)) ? 1 : -1
				);

				setRows(updatedRows);
				setCounts(updatedRows);
			})
			.catch((error: any) => {
				setError(error);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const setGridFilterCriteria = (value: string) => {
		if (!value.trim()) {
			setRows(Counts);
			return;
		}
		const newRows = Counts.filter(({ grnNumber, recievingDate }: any) => {
			return (
				grnNumber.toLowerCase().includes(value.toLowerCase()) ||
				recievingDate.toLowerCase().includes(value.toLowerCase())
			);
		});
		setRows(newRows);
	};

	const filterByDate = (startDate: Date, endDate: Date) => {
		if (startDate && endDate) {
			const sd = moment(startDate);
			const ed = moment(endDate);
			const newRows = Counts.filter(({ recievingDate }: any) => {
				return moment(recievingDate).isBetween(sd, ed, undefined, "[]");
			});
			setRows(newRows);
		} else setRows(Counts);
	};

	useEffect(() => {
		getData();
	}, [tenantId]);

	return (
		<ListPageDX
			listTitle={t("Counting")}
			name={t("Counting")}
			rows={rows}
			columns={CountColumns}
			getRowId={(row: any) => row.inboundRequestId}
			isLoading={isLoading}
			setGridFilterCriteria={setGridFilterCriteria}
			exportToPDF={false}
			exportToCSV={false}
			showDatePicker={true}
			filterByDate={filterByDate}
			onEdit={onEdit}
			buildActions={buildActions}
		/>
	);
};

export default CountList;
